module.exports = __webpack_public_path__ + "static/media/injuredHold.a85ffa85.mp3";